// @flow
import React from 'react'
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select
} from '@material-ui/core'
import i18n from 'i18next'
import styles from './styles'

type Props = {
  creditCards: Array<Object>,
  recurrent: Object,
  onSubmit: Function,
  onInputChange: Function
}

const CreditCardPicker = (props: Props) => (
  <Grid>
    <form onSubmit={props.onSubmit}>
      <FormControl
        fullWidth
        margin='none'
        required={props.recurrent.formFields.creditCard.required}
        variant='outlined'
        error={props.recurrent.formFields.creditCard.error}
        style={styles.selectorWrapper}
      >
        <InputLabel>{i18n.t('checkout.label.selectCreditCard')}</InputLabel>
        <Select
          value={props.recurrent.formFields.creditCard.value}
          onChange={props.onInputChange}
          input={
            <OutlinedInput
              labelWidth={260}
              name='creditCard'
              id='payment-creditCard'
            />
          }
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
          }}
        >
          {props.creditCards.map((creditCard, index) => (
            <MenuItem value={creditCard.number} key={index}>
              {creditCard.type}
              {` **** **** **** ${creditCard.number} `}
              {creditCard.expirationMonth}
              {'/'}
              {creditCard.expirationYear}
            </MenuItem>
          ))}
        </Select>
        {props.recurrent.formFields.creditCard.error && (
          <FormHelperText error>
            {i18n.t('checkout.error.selectCreditCard')}
          </FormHelperText>
        )}
      </FormControl>
    </form>
  </Grid>
)

export default CreditCardPicker
